import { render, staticRenderFns } from "./ShipmentGroup.vue?vue&type=template&id=346fd67b"
import script from "./ShipmentGroup.vue?vue&type=script&lang=js"
export * from "./ShipmentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports